var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{attrs:{"size":"is-small","type":"is-memed","icon-left":"plus","id":"memed-button","loading":_vm.isButtonDisabled,"disabled":_vm.isButtonDisabled},on:{"click":_vm.onMemedButtonClick}},[_vm._v(" Acessar Memed ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }